@if (payment) {
    <div class="header-label">{{ 'Receive Payment' }}</div>
}
@if (payment) {
    <div class="flex-fill d-flex flex-column">
        <div class="dx-card responsive-paddings">
            <div class="row">
                <div class="col-4">
                    @if (hasChanges()) {
                        <button (click)="save()" class="btn btn-success me-2">Save</button>
                    }
                    @if (hasChanges()) {
                        <button (click)="cancel()" class="btn btn-danger">Cancel</button>
                    }
                    @if (!hasChanges()) {
                        <button (click)="close()" class="btn btn-primary">Close</button>
                    }
                    <button (click)="saveAndSend()" class="btn btn-primary ms-5 me-2">Save & Send</button>
                    @if (!hasChanges() && readonly) {
                        <button (click)="printPaymentReceipt()" class="btn btn-primary ms-2">Print Payment</button>
                    }
                </div>
                <div class="col-5 d-flex align-items-center ms-auto">
                    <div class="d-flex ms-auto me-1 mt-2">
                        <div class="d-flex align-items-center me-5">
                            <label class="mt-2 me-2">Payment Date</label>
                            <dx-date-box [(value)]="payment.paymentDate"></dx-date-box>
                        </div>
                        <!-- <div class="d-flex align-items-center">
            <label class="me-2">Status</label>
            <h4 class="me-2">
              <strong>{{ payment.status?.name }}</strong>
            </h4>
            <button (click)="updateStatus()" class="btn btn-primary me-2">Update Status</button>
          </div> -->
                    </div>
                </div>
            </div>
            <div class="row" class="p-2">
                <dx-form [formData]="payment" [colCount]="6" validationGroup="invoiceValidationGroup" [disabled]="readonly">
                    <dxi-form-item itemType="group" caption="Customer">
                        @if (customer) {
                            <dxi-form-item>
                                <div *dxTemplate>
                                    <h3 class="mt-0 mb-1">{{ customer.displayName }}</h3>
                                    <div>{{ customer.billAddress1 }}</div>
                                    <div>{{ customer.billAddress2 }}</div>
                                    <div>
                                        {{ customer.billCity ? customer.billCity + ',' : '' }}
                                        {{ customer.billState }}
                                        {{ customer.billZip }}
                                    </div>
                                    <!-- <div *ngIf="useHaulingRate">Distance: {{ payment?.rental?.serviceAddress?.distance }}</div> -->
                                    <!-- <div *ngIf="useHaulingRate">Range: {{ payment?.rental?.serviceAddress?.range }}</div> -->
                                </div>
                            </dxi-form-item>
                        }
                    </dxi-form-item>
                    <dxi-form-item itemType="group" caption="Payment Info">
                        <dxi-form-item
                            dataField="paymentMethodId"
                            [label]="{ text: 'Method' }"
                            editorType="dxSelectBox"
                            [editorOptions]="{ dataSource: paymentMethods, valueExpr: 'id', displayExpr: 'name' }"
                        >
                        </dxi-form-item>
                        <dxi-form-item dataField="referenceNumber"></dxi-form-item>
                    </dxi-form-item>
                    <dxi-form-item itemType="group" caption="Totals">
                        <dxi-form-item [label]="{ text: 'Amount Received' }">
                            <div *dxTemplate>
                                <dx-number-box
                                    [(value)]="amountReceived"
                                    [step]="0"
                                    [readOnly]="true"
                                    [format]="{ type: 'currency', precision: 2 }"
                                    (onValueChanged)="creditCheck($event)"
                                ></dx-number-box>
                            </div>
                        </dxi-form-item>
                        <dxi-form-item [label]="{ text: 'Balance' }">
                            <div *dxTemplate>
                                <dx-number-box
                                    [(value)]="balance"
                                    [step]="0"
                                    [readOnly]="true"
                                    [format]="{ type: 'currency', precision: 2 }"
                                ></dx-number-box>
                            </div>
                        </dxi-form-item>
                        <dxi-form-item [label]="{ text: 'Credit' }">
                            <div *dxTemplate>
                                <dx-number-box
                                    [(value)]="creditAmount"
                                    [step]="0"
                                    [readOnly]="true"
                                    [format]="{ type: 'currency', precision: 2 }"
                                ></dx-number-box>
                            </div>
                        </dxi-form-item>
                    </dxi-form-item>
                    <dxi-form-item itemType="group" caption="QuickBooks Info">
                        <dxi-form-item dataField="quickBooksId" [label]="{ text: 'QuickBooks Id' }" [editorOptions]="{ readOnly: true }">
                        </dxi-form-item>
                        <dxi-form-item
                            dataField="quickBooksExport"
                            [label]="{ text: 'QuickBooks Last Exported' }"
                            [editorOptions]="{ readOnly: true }"
                        >
                        </dxi-form-item>
                    </dxi-form-item>
                </dx-form>
            </div>
        </div>
        <div class="flex-fill dx-card responsive-paddings">
            <dx-data-grid
                #invoiceLineGrid
                keyExpr="id"
                class="h-100"
                [dataSource]="paymentLines"
                [showBorders]="true"
                [showRowLines]="true"
                (onRowPrepared)="rowPrepare($event)"
                (onToolbarPreparing)="onToolbarPreparing($event)"
                (onRowDblClick)="rowDoubleClick($event)"
                (onRowUpdated)="rowUpdated($event)"
            >
                <dxi-data-grid-column
                    dataField="lineNumber"
                    caption="No."
                    [visible]="true"
                    width="80"
                    [sortIndex]="1"
                    [sortOrder]="'asc'"
                    [allowEditing]="false"
                ></dxi-data-grid-column>
                <dxi-data-grid-column dataField="description" width="325" [allowEditing]="false"></dxi-data-grid-column>
                <dxi-data-grid-column
                    dataField="invoiceDueDate"
                    caption="Due Date"
                    width="100"
                    [allowEditing]="false"
                ></dxi-data-grid-column>
                <dxi-data-grid-column
                    dataField="invoiceAmount"
                    [format]="{ type: 'currency', precision: 2 }"
                    width="125"
                    [allowEditing]="false"
                ></dxi-data-grid-column>
                <dxi-data-grid-column
                    dataField="startingBalance"
                    [format]="{ type: 'currency', precision: 2 }"
                    [visible]="key === 'new'"
                    width="100"
                    [allowEditing]="false"
                ></dxi-data-grid-column>
                <dxi-data-grid-column
                    dataField="remainingBalance"
                    [format]="{ type: 'currency', precision: 2 }"
                    width="100"
                    [allowEditing]="false"
                ></dxi-data-grid-column>
                <dxi-data-grid-column
                    dataField="amount"
                    [format]="{ type: 'currency', precision: 2 }"
                    width="100"
                    [allowEditing]="!readonly"
                    [editorOptions]="{ step: 0 }"
                ></dxi-data-grid-column>
                <dxi-data-grid-column
                    dataField="relatedPaymentIds"
                    caption="Related Payments"
                    [allowEditing]="false"
                    width="150"
                    cellTemplate="relatedPaymentTemplate"
                ></dxi-data-grid-column>
                <dxi-data-grid-column dataField="notes" [allowEditing]="true"></dxi-data-grid-column>
                <div *dxTemplate="let cell of 'relatedPaymentTemplate'">
                    @for (paymentId of cell.data.relatedPaymentIds; track paymentId; let i = $index) {
                        <span class="pe-1">
                            @if (cell) {
                                <a [routerLink]="[]" (click)="openPayment(paymentId)"
                                    >#{{ paymentId + (i + 1 < cell.data.relatedPaymentIds.length ? ', ' : '') }}</a
                                >
                            }
                        </span>
                    }
                </div>
                <dxo-data-grid-editing [mode]="'cell'" [allowUpdating]="true"></dxo-data-grid-editing>
                <dxo-data-grid-selection [mode]="'multiple'" [showCheckBoxesMode]="'always'"></dxo-data-grid-selection>
                <dxo-data-grid-state-storing
                    [enabled]="true"
                    type="localStorage"
                    storageKey="invoice-lines-grid"
                ></dxo-data-grid-state-storing>
                <div *dxTemplate="let data of 'toolbarButtons'">
                    <!-- <button
          class="btn btn-danger me-2 mb-2"
          (click)="removeInvoiceLine(invoiceLineGrid.instance.getSelectedRowsData()[0])"
          [disabled]="invoiceLineGrid.instance.getSelectedRowsData().length !== 1"
          >
          Clear Payments
        </button> -->
                </div>
            </dx-data-grid>
        </div>
        <div class="dx-card responsive-paddings">
            <dx-form [formData]="payment" [colCount]="2">
                <dxi-form-item
                    dataField="notes"
                    editorType="dxTextArea"
                    [label]="{ text: 'Payment Memos' }"
                    [editorOptions]="{ height: 100 }"
                >
                </dxi-form-item>
            </dx-form>
        </div>
    </div>
}
